<template>
  <div id="company">
    <TitleComponent />
    <div class="d-lg-flex">
      <div class="col-lg-3 p-1">
        <div class="card mt-3 p-3">
          <div class="card-body">
            <CompanyCreateComponent />
          </div>
        </div>
      </div>
      <div class="col p-1">
        <div class="card mt-3 p-3">
          <div class="card-body">
            <div class="d-lg-flex d-md-flex">
              <div class="p-1">
                <label for="exampleFormControlInput1">Search</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Search here"
                  v-model="search"
                  @keyup.enter="readAll"
                />
              </div>
            </div>
            <div class="table-container mt-2">
              <div class="table-wrapper">
                <table class="table table-sm table-hover table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th width="10">No</th>
                      <th width="100">Bucket</th>
                      <th width="100">Name</th>
                      <th width="100">User Created</th>
                      <th width="100" class="fixed-col">Aksi</th>
                    </tr>
                  </thead>
                  <tbody v-if="datas && datas.length > 0">
                    <tr v-for="(n, i) in datas" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td>{{ n.compcode }}</td>
                      <td>{{ n.compname }}</td>
                      <td>{{ n.ucreated }}</td>
                      <td class="fixed-col">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div
                            class="icon-card"
                            data-bs-toggle="modal"
                            data-bs-target="#modaDetailCompany"
                            @click="readOne(n.compcode)"
                          >
                            <i class="fas fa-edit icon"></i>
                          </div>
                          <div
                            class="icon-card"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteModal"
                            @click="id = n.compcode"
                          >
                            <i class="fas fa-trash icon"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="datas && datas.length < 1">
                    <tr class="text-center">
                      <td colspan="6" class="p-2">Data is missing</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="table-footer mt-2 d-lg-flex d-md-flex justify-content-between align-items-center"
            >
              <DataPageComponent
                :perPage="pagination.perPage"
                :currentPage="pagination.currentPage"
                :totalItems="pagination.totalItems"
              />
              <div
                class="col d-flex justify-content-lg-end justify-content-md-end justify-content-center"
              >
                <PaginationComponent
                  :pagination="pagination"
                  @goto-page="readAll"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CompanyDetailComponent :datas="detail" />
    <DeleteModalComponent
      title="DELETE COMPANY"
      descript="COMPANY ?"
      :id="id"
      :text="text"
      @saveDelete="deleteCompany"
    />
  </div>
</template>
<script>
import DataPageComponent from "@/components/DataPageComponent.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import CompanyCreateComponent from "@/components/company/CompanyCreateComponent.vue";
import DeleteModalComponent from "@/components/DeleteModalComponent.vue";
import TitleComponent from "@/components/TitleComponent.vue";
import { getPage } from "@/utils/HandleToken";
import { mapActions, mapState } from "vuex";
import CompanyDetailComponent from "@/components/company/CompanyDetailComponent.vue";

export default {
  name: "CompanyView",
  data() {
    return {
      id: "",
    };
  },
  components: {
    TitleComponent,
    CompanyCreateComponent,
    DataPageComponent,
    PaginationComponent,
    DeleteModalComponent,
    CompanyDetailComponent,
  },
  computed: {
    ...mapState({
      datas: (state) => state.Company.datas,
      pagination: (state) => state.Company.pagination,
      detail: (state) => state.Company.detail,
    }),
    search: {
      get() {
        return this.$store.state.Company.search;
      },
      set(value) {
        this.$store.commit("Company/SET_SEARCH", value);
      },
    },
  },
  methods: {
    ...mapActions({
      readAll: "Company/readAll",
      deleteCompany: "Company/delete",
      readOne: "Company/readOne",
    }),
  },
  created() {
    const currentPpage = getPage();
    this.readAll(currentPpage);
  },
};
</script>
